export default [
  'erika.lazaro@foodforjoe.es',
  'diego@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'albane@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'jonathan@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
  'compras@foodforjoe.es',
  'juan@foodforjoe.es',
];
